import { render, staticRenderFns } from "./Simon.vue?vue&type=template&id=3558a445&"
import script from "./Simon.vue?vue&type=script&lang=js&"
export * from "./Simon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports